<template>
  <v-container fluid>
    <GsMessageLog appSettingKey="messages" />
  </v-container>
</template>

<script>
import GsMessageLog from "@/components/GsMessageLog";

export default {
  name: "MessageLog",
  components: {
    GsMessageLog
  },
  data() {
    return {};
  }
};
</script>
